import { theme } from "twin.macro";
import { Link } from "react-router-dom";
import Button from "@/components/Atoms/Button";

import IconPinLocation from "@iconsV2/Interrface/pin-location.svg?react";
import IconClock from "@iconsV2/Calendar/clock.svg?react";
import IconCombinator from "@iconsV2/Backed/combinator.svg?react";
import IconIndustria from "@iconsV2/Backed/industria.svg?react";
import IconFlagColombia from "@iconsV2/Flags/colombia.svg?react";
import IconInstagramWhite from "@iconsV2/SocialIcon/instagram-white.svg?react";
import IconFacebookWhite from "@iconsV2/SocialIcon/facebook-white.svg?react";
import IconYoutubeWhite from "@iconsV2/SocialIcon/youtube-white.svg?react";
import IconLinkedInWhite from "@iconsV2/SocialIcon/linkedin-white.svg?react";
import Paragraph from "@/components/Atoms/Paragraph";
import { ORGANIZATION_CONTACT_NUMBER, ORGANIZATION_EMAIL } from "@/recourses/constants";
import Caption from "@/components/Atoms/Caption";
import Heading from "@/components/Atoms/Heading";
// import IconBook from "@components/Icons/V2/Interrface/book-03.svg?react";
import IconLayer02 from "@components/Icons/V2/Interrface/layers-02.svg?react";
import srcStamp from "@/assets/footer/stamp-03.webp";
import Image from "@/components/Atoms/Image";
import IconCalendarEmpty from "@iconsV2/Calendar/calendar-empty.svg?react";
import IconCallPhone from "@iconsV2/Chat/call-phone.svg?react";
import IconStore from "@iconsV2/Interrface/store.svg?react";
import IconMail from "@iconsV2/Chat/mail.svg?react";
import { openChat } from "@/utils/openChat";
import ButtonText from "@/components/Atoms/ButtonText";
import BrandLogoFithub from "@/components/Atoms/BrandLogoFithub";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { openNewsletter } from "@/utils/openNewsletter";
import dayjs from "@utils/dayjs";
import {
  StyledHr,
  StyledInfoNewLetter,
  StyledLinksSection,
  StyledSectionNewLetter,
  StyledSectionQuickLinks,
  StyledText,
  StyledWrapperCity,
  StyledWrapperFooter,
  StyledContactContainer,
  StyledContactWrapper,
  StyledColumnContact,
  StyledRowContact,
  StyledWrapperSocialNetwork,
  StyledLegalSection,
  StyledFooterRoot,
  StyledSectionBusinessHours,
  StyledLegalLinksContainer,
  StyledBrandContainer,
  StyledTextContact,
  StyledAddressItem,
} from "./styles";
import { formatPhoneNumber } from "@/utils/formatters";
import { allStores, isOpenForBusiness } from "@/utils/stores";
import { useState } from "react";
import TagsVR3 from "@/components/Atoms/TagsVR3";

const BUSINESS_HOURS = {
  lunVie: "Lun - Vie 8 am - 8 pm",
  sabDom: "Sáb y Dom  10 am - 6 pm",
};

const SOCIAL_NETWORK = [
  { name: "Instagram", url: "https://www.instagram.com/fithub_co/", Icon: IconInstagramWhite },
  { name: "Facebook", url: "https://www.facebook.com/FitHubco", Icon: IconFacebookWhite },
  {
    name: "Youtube",
    url: "https://www.youtube.com/channel/UCCVbPuguSB8X7CU7jZdgsoQ",
    Icon: IconYoutubeWhite,
  },
  { name: "LinkedIn", url: "https://www.linkedin.com/company/fithub-colombia", Icon: IconLinkedInWhite },
];

const getYear = () => {
  return dayjs().year();
};

const Footer = () => {
  const [isFetchRequested, setIsFetchRequested] = useState({
    chat: false,
    newsletter: false,
  });
  const isMedium = useMediaQuery("(min-width: {medium})");
  const isLarge = useMediaQuery("( min-width: {large} )");
  const textColor = theme`colors.neutral.100`;
  // Filter address data by store availables

  const handleOpenChat = async () => {
    try {
      setIsFetchRequested({
        ...isFetchRequested,
        chat: true,
      });
      await openChat();
    } finally {
      setIsFetchRequested({
        ...isFetchRequested,
        chat: false,
      });
    }
  };

  const handleOpenNewsletter = async () => {
    try {
      setIsFetchRequested({
        ...isFetchRequested,
        newsletter: true,
      });
      await openNewsletter();
    } finally {
      setIsFetchRequested({
        ...isFetchRequested,
        newsletter: false,
      });
    }
  };

  return (
    <StyledFooterRoot>
      <StyledWrapperFooter id="footer">
        {/* Section Business Hours  */}
        <StyledSectionBusinessHours>
          <Heading type="h5" color={textColor}>
            Encuéntranos en
          </Heading>
          <StyledWrapperCity>
            {allStores?.map((location) => {
              const open = isOpenForBusiness(location);
              return (
                <div key={location.city}>
                  <div>
                    <Paragraph sizeVariant="sm" color={textColor} fontWeight={600}>
                      {location.city}
                    </Paragraph>
                    <Caption
                      color={open ? theme`colors.tertiary.60` : theme`colors.error.80`}
                      fontWeight={600}
                    >
                      {open ? "Abierto" : "Cerrado"}
                    </Caption>
                  </div>

                  {location.stores.map((store, i) => (
                    <>
                      {store.address && store.to && (
                        <StyledAddressItem>
                          <Link
                            to={store.to}
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label={`Ubicación ${location.city} en Google Maps ${store.address}`}
                            title={`Ubicación ${location.city} en Google Maps ${store.address}`}
                            key={i}
                          >
                            <IconPinLocation />
                            <StyledText sizeVariant="sm">{store.address}</StyledText>
                          </Link>

                          {store.new && <TagsVR3 label="Nuevo" type="sponsor" separator="dot" />}
                        </StyledAddressItem>
                      )}
                    </>
                  ))}

                  <div>
                    <IconClock />
                    <StyledText sizeVariant="sm">{location.hour}</StyledText>
                  </div>
                </div>
              );
            })}
          </StyledWrapperCity>
        </StyledSectionBusinessHours>

        {!isMedium && <StyledHr tw="w-full" />}

        {/* Section Quick Links ["Blog", "vende con nosotros"] */}
        <StyledSectionQuickLinks>
          <div>
            <Heading type="h5" color={textColor} tw="mb-m">
              Enlaces rápidos
            </Heading>
            <StyledLinksSection>
              {/* <Button
                className="link-item"
                color="secondary"
                variant="text"
                sizeVariant="md"
                as={Link}
                to={"https://blog.fithub.com.co"}
                target="_blank"
                rel="noopener noreferrer"
                title={`Blog de Fithub`}
                aria-label="Blog"
                startIcon={<IconBook />}
              >
                Blog
              </Button> */}

              <Button
                className="link-item"
                color="secondary"
                variant="text"
                sizeVariant="md"
                as={Link}
                to={"https://leads-fithub.subrik.com"}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Vende con nosotros"
                title="Vende con nosotros"
                startIcon={<IconLayer02 />}
              >
                Vende con nosotros
              </Button>

              <Button
                className="link-item"
                color="secondary"
                variant="text"
                sizeVariant="md"
                as={Link}
                to={"/stores"}
                aria-label="Conoce nuestras tiendas"
                title="Conoce nuestras tiendas"
                startIcon={<IconStore />}
              >
                Nuestras tiendas
              </Button>
            </StyledLinksSection>
          </div>
          <Image
            src={srcStamp}
            alt="Que tengas un día bacano by Fithub"
            title="Que tengas un día bacano by Fithub"
            tw="w-[6.625rem] h-[6.875rem]"
          />

          {isLarge && (
            <StyledSectionNewLetter>
              <StyledInfoNewLetter>
                <Heading type="h5" color={textColor} tw="mb-m">
                  ¡No te pierdas nada!
                </Heading>
                <Paragraph sizeVariant="sm" color={textColor} tw="mb-s">
                  Recibe en tu correo las últimas ofertas, deliciosas recetas y consejos de estilo de vida.
                </Paragraph>
                <Button
                  sizeVariant="md"
                  color="secondary"
                  variant="outlined"
                  tw="bg-transparent text-secondary-85 border-secondary-85 min-w-[19.196rem]"
                  onClick={handleOpenNewsletter}
                  loading={isFetchRequested.newsletter}
                >
                  Suscríbete a nuestro newsletter
                </Button>
              </StyledInfoNewLetter>
              <div tw="flex items-center justify-between">
                <IconCombinator tw="w-[7rem] h-[1.5rem]" />
                <IconIndustria tw="w-[8.25rem] h-[2rem]" />
              </div>
            </StyledSectionNewLetter>
          )}
        </StyledSectionQuickLinks>

        <StyledHr tw="medium:(row-start-2 col-start-1 col-end-3) large:(col-span-3)" />

        {/* Section NewLetter */}
        {!isLarge && (
          <StyledSectionNewLetter>
            <StyledInfoNewLetter>
              <Heading type="h5" color={textColor} tw="mb-m">
                ¡No te pierdas nada!
              </Heading>
              <Paragraph sizeVariant="sm" color={textColor} tw="mb-s">
                Recibe en tu correo las últimas ofertas, deliciosas recetas y consejos de estilo de vida.
              </Paragraph>
              <Button
                sizeVariant="md"
                color="secondary"
                variant="outlined"
                tw="bg-transparent text-secondary-85 border-secondary-85 min-w-[15.181rem] medium:(min-w-[17.189rem])"
                onClick={handleOpenNewsletter}
                loading={isFetchRequested.newsletter}
              >
                Suscríbete a nuestro newsletter
              </Button>
            </StyledInfoNewLetter>
            <div tw="flex items-center justify-between">
              <IconCombinator tw="w-[7rem] h-[1.5rem]" />
              <IconIndustria tw="w-[8.25rem] h-[2rem]" />
            </div>
          </StyledSectionNewLetter>
        )}

        {!isMedium && <StyledHr />}
        <StyledContactContainer>
          <Heading type="h5" color={textColor} tw="mb-m">
            ¿Necesitas ayuda?
          </Heading>

          <StyledContactWrapper>
            <StyledColumnContact>
              <Paragraph sizeVariant="sm" color={textColor} fontWeight={600}>
                Horario de atención
              </Paragraph>
              {Object.entries(BUSINESS_HOURS).map(([key, value]) => (
                <StyledRowContact key={key}>
                  <IconCalendarEmpty />
                  <StyledTextContact sizeVariant="sm" color={textColor}>
                    {value}
                  </StyledTextContact>
                </StyledRowContact>
              ))}
            </StyledColumnContact>

            <StyledColumnContact>
              <Paragraph sizeVariant="sm" color={textColor} fontWeight={600}>
                Línea de atención
              </Paragraph>
              <StyledRowContact>
                <IconCallPhone />
                <a
                  href={`tel:+${ORGANIZATION_CONTACT_NUMBER}`}
                  aria-label={`Llamar al número ${formatPhoneNumber(ORGANIZATION_CONTACT_NUMBER)}`}
                  title={`Llamar al número ${formatPhoneNumber(ORGANIZATION_CONTACT_NUMBER)}`}
                >
                  <StyledTextContact sizeVariant="sm" color={textColor} tw="underline">
                    {formatPhoneNumber(ORGANIZATION_CONTACT_NUMBER)}
                  </StyledTextContact>
                </a>
              </StyledRowContact>
            </StyledColumnContact>

            <StyledColumnContact>
              <Paragraph sizeVariant="sm" color={textColor} fontWeight={600}>
                Correo electrónico
              </Paragraph>
              <StyledRowContact>
                <IconMail />
                <a
                  href={`mailto:${ORGANIZATION_EMAIL}`}
                  rel="noopener noreferrer"
                  target="_blank"
                  tw="cursor-pointer"
                >
                  <StyledTextContact sizeVariant="sm" color={textColor} tw="underline">
                    {ORGANIZATION_EMAIL}
                  </StyledTextContact>
                </a>
              </StyledRowContact>
            </StyledColumnContact>

            <Button
              sizeVariant="md"
              tw="w-max bg-transparent text-secondary-85 border-secondary-85 min-w-[12.824rem]"
              color="secondary"
              variant="outlined"
              onClick={handleOpenChat}
              loading={isFetchRequested.chat}
            >
              Chatea con nosotros
            </Button>
          </StyledContactWrapper>
        </StyledContactContainer>
        {!isLarge && <StyledHr tw="col-start-1 col-end-3" />}

        <StyledLegalSection>
          <StyledWrapperSocialNetwork>
            {SOCIAL_NETWORK.map(({ name, url, Icon }) => {
              return (
                <Link key={name} rel="noopener noreferrer" target="_blank" title={name} to={url}>
                  <Icon />
                </Link>
              );
            })}
          </StyledWrapperSocialNetwork>

          <StyledLegalLinksContainer>
            <ButtonText
              sizeVariant="sm"
              color={textColor}
              as={Link}
              rel="noopener noreferrer"
              target="_blank"
              to={"/terms"}
              aria-label="Terminos y condiciones"
              title="Terminos y condiciones"
              className="link-legals"
            >
              Términos y condiciones
            </ButtonText>

            <ButtonText
              sizeVariant="sm"
              color={textColor}
              as={Link}
              rel="noopener noreferrer"
              target="_blank"
              to={"/policy"}
              aria-label="Politicas de privacidad"
              title="Politicas de privacidad"
              className="link-legals"
            >
              Politicas de privacidad
            </ButtonText>
          </StyledLegalLinksContainer>

          <StyledBrandContainer>
            <BrandLogoFithub tw="w-[108px] h-[32px]" />

            <div tw="flex items-end gap-m">
              <Paragraph sizeVariant="sm" color={textColor}>
                © {getYear()} fithub
              </Paragraph>
              <IconFlagColombia width={24} height={24} />
            </div>
          </StyledBrandContainer>
        </StyledLegalSection>
      </StyledWrapperFooter>
    </StyledFooterRoot>
  );
};

export default Footer;
